// import {
//   ArrowCircleLeftOutlined,
//   ArrowCircleRightOutlined,
//   ChevronLeft,
//   ChevronRight,
//   Close,
//   PlayArrow,
// } from '@mui/icons-material';
// import { Box, Card, CardContent, IconButton, Modal, Typography } from '@mui/material';
// import { set } from 'lodash';
// import React from 'react';
// import { baseVideoUrl } from '../../../../api';
// import theme from '../../../../theme';
// import { imageCategories, imageFieldToImageCategoriesMap } from '../../../../utils/constants/carData';
// import { getCategoryFromUrl } from '../../../../utils/methods/generalVehicleMethods';

// export const CarCarousel = ({ images, Vehicle_Id, Vehicle_video = null, vehicleData = {} }) => {
//   // Create combined media array with images and video
//   const [index, setIndex] = React.useState(0);
//   const [popUpImageIndex, setPopUpImageIndex] = React.useState(0);
//   const [showCarousel, setShowCarousel] = React.useState(false);
//   const [selectedCategory, setSelectedCategory] = React.useState("all");

//   const mediaItems = React.useMemo(() => {
//     const items = [];

//     // Add video first if it exists
//     if (Vehicle_video) {
//       items.push({
//         type: 'video',
//         src: `${baseVideoUrl}/${Vehicle_Id}/${Vehicle_video}`,
//         alt: 'Vehicle Video',
//       });
//     }

//     // Add images
//     if (images?.length) {
//       images.forEach((src, index) => {

//         items.push({
//           type: 'image',
//           src: src,
//           alt: `Image ${index + 1}`,
//           category: imageCategories[getCategoryFromUrl(src)]
//         });
//       });
//     }

//     return items;
//   }, [images, Vehicle_Id, Vehicle_video]);


//   const categorizedMedia = React.useMemo(() => {
//     const groups = {
//       interior: [],
//       exterior: [],
//       rims: [],
//       dashboard: [],
//       damage: [],
//       all: []
//     };

//     mediaItems.forEach(item => {
//       groups.all.push(item);

//       if (item.category && groups[item.category]) {
//         groups[item.category].push(item);
//       }
//     });

//     return groups;
//   }, [mediaItems]);

//   const filteredItems = categorizedMedia[selectedCategory] || [];


//   const handleNext = () => {
//     setIndex((prev) => (prev + 1) % mediaItems.length);
//   };

//   const handlePrev = () => {
//     setIndex((prev) => (prev - 1 + mediaItems.length) % mediaItems.length);
//   };

//   const handlePopupNext = () => {
//     setPopUpImageIndex((prev) => (prev + 1) % mediaItems.length);
//   };

//   const handlePopupPrev = () => {
//     setPopUpImageIndex((prev) => (prev - 1 + mediaItems.length) % mediaItems.length);
//   };

//   const handleLineClick = (i) => {
//     setIndex(i);
//   };

//   const handleCarouselModalClose = () => {
//     setShowCarousel(false);
//   };

//   React.useEffect(() => {
//     setIndex(0);            // main carousel index
//     setPopUpImageIndex(0);  // modal index
//   }, [selectedCategory]);

//   console.log('mediaItems', mediaItems, images, Vehicle_video);

//   return (
//     <>
//       {mediaItems?.length > 0 ? (
//         <Card
//           elevation={0}
//           sx={{
//             position: 'relative',
//             bgcolor: theme.palette.mode === 'dark' ? 'rgba(253, 253, 253, 0.05)' : '#fafafa',
//             border: '1px solid #f0f0f0',
//             mb: 2,
//             borderRadius: '8px',
//           }}
//         >
//           <Box p={'1rem 1rem 0rem 1rem'}>
//             <Box
//               display="flex"
//               alignItems="center"
//               borderRadius="10px"
//               zIndex={1}
//             >
//               <Typography variant="h5" fontWeight={700} color={theme.palette.primary.main}>
//                 {`${vehicleData?.Year || ''} ${vehicleData?.Make || ''} ${vehicleData?.Model || ''} ${
//                   vehicleData?.Trim || ''
//                 } ${vehicleData?.Engine || ''} ${vehicleData?.Transmission_Type || ''}`.trim()}
//               </Typography>
//             </Box>
//           </Box>
//           <CardContent sx={{ p: 2 }}>
//             <Box
//               display="flex"
//               flexDirection="column"
//               alignItems="center"
//               gap="0.75rem"
//               sx={{
//                 width: '100%',
//               }}
//             >
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 gap="1rem"
//                 sx={{
//                   width: '100%',
//                 }}
//               >
//                 <Box
//                   display="flex"
//                   gap="0.5rem"
//                   overflow="hidden"
//                   sx={{
//                     width: '100%',
//                   }}
//                 >
//                   {mediaItems?.map((item, i) => (
//                     <Box
//                       key={i}
//                       width="40%"
//                       // minWidth="300px"
//                       maxWidth="500px"
//                       height="300px"
//                       borderRadius="1rem"
//                       flexShrink={0}
//                       position="relative"
//                       sx={{
//                         cursor: 'pointer',
//                         transform: `translateX(-${index * (images.length + 440)}px)`,
//                         transition: 'transform 0.5s ease-in-out',
//                         bgcolor: 'white',
//                         border: '1px solid #f0f0f0',
//                       }}
//                       onClick={() => {
//                         setIndex(i);
//                         setPopUpImageIndex(i);
//                         setShowCarousel(true);
//                       }}
//                     >
//                       {item.type === 'video' ? (
//                         <>
//                           <Box
//                             component="video"
//                             src={item.src}
//                             muted
//                             sx={{
//                               width: '100%',
//                               height: '100%',
//                               objectFit: 'cover',
//                               borderRadius: '1rem',
//                             }}
//                           />
//                           <Box
//                             sx={{
//                               position: 'absolute',
//                               top: '50%',
//                               left: '50%',
//                               transform: 'translate(-50%, -50%)',
//                               bgcolor: 'rgba(0, 0, 0, 0.7)',
//                               borderRadius: '50%',
//                               width: '48px',
//                               height: '48px',
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               color: 'white',
//                             }}
//                           >
//                             <PlayArrow sx={{ fontSize: '28px' }} />
//                           </Box>
//                         </>
//                       ) : (
//                         <Box
//                           component="img"
//                           src={item.src}
//                           alt={item.alt}
//                           sx={{
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'cover',
//                             borderRadius: '1rem',
//                           }}
//                         />
//                       )}
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>

//               {/* Navigation lines for all media items */}
//               <Box display="flex" justifyContent="center" alignItems={'center'} gap="0.3rem" width="50%">
//                 <IconButton
//                   onClick={handlePrev}
//                   sx={{ p: 0, mr: '8px', color: '#1976d2' }}
//                   disabled={mediaItems.length <= 1}
//                 >
//                   <ArrowCircleLeftOutlined />
//                 </IconButton>
//                 {mediaItems?.map((_, i) => (
//                   <Box
//                     key={i}
//                     onClick={() => handleLineClick(i)}
//                     sx={{
//                       height: '0.3rem',
//                       flex: 1,
//                       backgroundColor: i === index ? '#1976d2' : '#e0e0e0',
//                       borderRadius: '0.15rem',
//                       cursor: 'pointer',
//                       transition: 'background-color 0.3s ease',
//                       '&:hover': {
//                         backgroundColor: i === index ? '#1976d2' : '#bdbdbd',
//                       },
//                     }}
//                   />
//                 ))}
//                 <IconButton
//                   onClick={handleNext}
//                   sx={{ p: 0, ml: '8px', color: '#1976d2' }}
//                   disabled={mediaItems.length <= 1}
//                 >
//                   <ArrowCircleRightOutlined />
//                 </IconButton>
//               </Box>
//             </Box>
//           </CardContent>

//           {showCarousel ? (
//             <Modal
//               open={showCarousel}
//               onClose={handleCarouselModalClose}
//               keepMounted
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//             >
//               <Box
//                 sx={{
//                   position: 'relative',
//                   width: { xs: '90%', sm: '80%', md: '70%', lg: '60%' },
//                   maxWidth: '800px',
//                   maxHeight: '90vh',
//                   bgcolor: 'white',
//                   borderRadius: '8px',
//                   boxShadow: 24,
//                   outline: 'none',
//                   overflow: 'hidden',
//                   border: '1px solid #f0f0f0',
//                 }}
//               >
//                 {/* Close Button */}
//                 <IconButton
//                   onClick={handleCarouselModalClose}
//                   sx={{
//                     position: 'absolute',
//                     top: 4,
//                     right: 4,
//                     zIndex: 2,
//                     bgcolor: 'rgba(0, 0, 0, 0.5)',
//                     color: 'white',
//                     width: '32px',
//                     height: '32px',
//                     '&:hover': {
//                       bgcolor: 'rgba(0, 0, 0, 0.7)',
//                     },
//                   }}
//                 >
//                   <Close sx={{ fontSize: '18px' }} />
//                 </IconButton>

//                 {/* Previous Button */}
//                 <IconButton
//                   onClick={handlePopupPrev}
//                   sx={{
//                     position: 'absolute',
//                     left: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     zIndex: 2,
//                     bgcolor: 'rgba(0, 0, 0, 0.5)',
//                     color: 'white',
//                     width: '32px',
//                     height: '32px',
//                     '&:hover': {
//                       bgcolor: 'rgba(0, 0, 0, 0.7)',
//                     },
//                     '&:disabled': {
//                       bgcolor: 'rgba(0, 0, 0, 0.3)',
//                       color: 'rgba(255, 255, 255, 0.5)',
//                     },
//                   }}
//                   disabled={mediaItems.length <= 1}
//                 >
//                   <ChevronLeft sx={{ fontSize: '18px' }} />
//                 </IconButton>

//                 {/* Next Button */}
//                 <IconButton
//                   onClick={handlePopupNext}
//                   sx={{
//                     position: 'absolute',
//                     right: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     zIndex: 2,
//                     bgcolor: 'rgba(0, 0, 0, 0.5)',
//                     color: 'white',
//                     width: '32px',
//                     height: '32px',
//                     '&:hover': {
//                       bgcolor: 'rgba(0, 0, 0, 0.7)',
//                     },
//                     '&:disabled': {
//                       bgcolor: 'rgba(0, 0, 0, 0.3)',
//                       color: 'rgba(255, 255, 255, 0.5)',
//                     },
//                   }}
//                   disabled={mediaItems.length <= 1}
//                 >
//                   <ChevronRight sx={{ fontSize: '18px' }} />
//                 </IconButton>

//                 {/* Media Container */}
//                 <Box
//                   sx={{
//                     width: '100%',
//                     minHeight: '300px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     bgcolor: 'white',
//                     pb: 5,
//                   }}
//                 >
//                   {mediaItems[popUpImageIndex]?.type === 'video' ? (
//                     <Box
//                       component="video"
//                       controls
//                       autoPlay
//                       src={mediaItems[popUpImageIndex]?.src}
//                       sx={{
//                         maxWidth: '100%',
//                         maxHeight: '100%',
//                         borderRadius: '4px',
//                       }}
//                     />
//                   ) : (
//                     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                       <img
//                         src={mediaItems[popUpImageIndex]?.src}
//                         alt={mediaItems[popUpImageIndex]?.alt}
//                         style={{
//                           maxWidth: '100%',
//                           maxHeight: '100%',
//                           objectFit: 'cover',
//                           borderRadius: '4px',
//                         }}
//                       />
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           my: 1,
//                           fontSize: '0.75rem',
//                           color: '#555',
//                           backgroundColor: 'rgba(255, 255, 255, 0.7)',
//                           px: 1,
//                           borderRadius: '4px',
//                           textAlign: 'center',
//                         }}
//                       >
//                         Note: {mediaItems[popUpImageIndex]?.alt}
//                       </Typography>
//                     </Box>
//                   )}
//                 </Box>

//                 {/* Media Counter */}
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     bottom: 8,
//                     left: '50%',
//                     transform: 'translateX(-50%)',
//                     bgcolor: 'rgba(0, 0, 0, 0.7)',
//                     color: 'white',
//                     px: 1.5,
//                     py: 0.5,
//                     borderRadius: '12px',
//                     fontSize: '0.75rem',
//                     fontWeight: 500,
//                   }}
//                 >
//                   {popUpImageIndex + 1} / {mediaItems.length}
//                 </Box>
//               </Box>
//             </Modal>
//           ) : null}
//         </Card>
//       ) : null}
//     </>
//   );
// };
////////////////////////////////////////////////////////////////////////////////////////////////
import {
  ArrowCircleLeftOutlined,
  ArrowCircleRightOutlined,
  ChevronLeft,
  ChevronRight,
  Close,
  PlayArrow,
} from '@mui/icons-material';
import { Box, Card, CardContent, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';
import { baseVideoUrl } from '../../../../api';
import theme from '../../../../theme';
import { imageCategories } from '../../../../utils/constants/carData';
import { getCategoryFromUrl } from '../../../../utils/methods/generalVehicleMethods';
import { getCommaFormattedNumber } from '../../../../utils/methods/stringMethods';
import { exportAuction, localAuction } from '../../../../utils/constants/auction';
import { useTranslation } from 'react-i18next';

export const CarCarousel = ({ images, Vehicle_Id, Vehicle_video = null, vehicleData = {}, dontShowVehicleTitle = false }) => {

  const { t } = useTranslation("liveAuction");

  const [index, setIndex] = React.useState(0); // main carousel index
  const [popUpImageIndex, setPopUpImageIndex] = React.useState(0); // modal index
  const [showCarousel, setShowCarousel] = React.useState(false);
  const [selectedCategory, setSelectedCategory] = React.useState('all');

  // Build media items (ALL ITEMS for outside carousel)
  const mediaItems = React.useMemo(() => {
    const items = [];

    if (Vehicle_video) {
      items.push({
        type: 'video',
        src: `${baseVideoUrl}/${Vehicle_Id}/${Vehicle_video}`,
        alt: 'Vehicle Video',
        category: 'all',
      });
    }

    (images || []).forEach((src, i) => {
      const catKey = getCategoryFromUrl(src);
      const mappedCat = imageCategories[catKey] || (catKey || 'all');

      items.push({
        type: 'image',
        src: src,
        alt: `Image ${i + 1}`,
        // label: src?.label,
        category: mappedCat,
      });
    });

    return items;
  }, [images, Vehicle_Id, Vehicle_video]);

  // Group by category
  const categorizedMedia = React.useMemo(() => {
    const groups = { interior: [], exterior: [], rims: [], damage: [], all: [] };

    mediaItems.forEach((item) => {
      groups.all.push(item);
      if (groups[item.category]) {
        groups[item.category].push(item);
      }
    });

    return groups;
  }, [mediaItems]);

  const filteredItems = categorizedMedia[selectedCategory] || [];

  // Reset modal index when changing category
  React.useEffect(() => {
    setPopUpImageIndex(0);
  }, [selectedCategory]);

  // MAIN NEXT / PREV (outside)
  const handleNext = () => {
    if (mediaItems.length === 0) return;
    setIndex((prev) => Math.min(prev + 1, mediaItems.length - 4)); // 4 per slide
  };

  const handlePrev = () => {
    if (mediaItems.length === 0) return;
    setIndex((prev) => Math.max(prev - 1, 0));
  };

  // MODAL NEXT / PREV
  const handlePopupNext = () => {
    if (filteredItems.length === 0) return;
    setPopUpImageIndex((prev) => (prev + 1) % filteredItems.length);
  };

  const handlePopupPrev = () => {
    if (filteredItems.length === 0) return;
    setPopUpImageIndex((prev) => (prev - 1 + filteredItems.length) % filteredItems.length);
  };

  const openModalAt = (i) => {
    setSelectedCategory('all');
    setPopUpImageIndex(i);
    setShowCarousel(true);
  };

  if (mediaItems.length === 0) return null;

  console.log("CarCarousel", mediaItems, images);

  return (
    <>
      <Card
        elevation={0}
        sx={{
          position: 'relative',
          bgcolor: theme.palette.mode === 'dark' ? 'rgba(253,253,253,0.05)' : '#fafafa',
          border: '1px solid #f0f0f0',
          mb: 2,
          borderRadius: '8px',
        }}
      >
        {/* Title */}
        {!dontShowVehicleTitle ? <Box p={'1rem 1rem 0rem 1rem'}>
          <Typography variant="h6" fontWeight="bold"
            sx={{
              fontSize: "1.75rem",
            }}
          >
            {vehicleData?.Year} {vehicleData?.Make} {vehicleData?.Model}
          </Typography>
          <Typography variant="body2" color={theme.palette.text.primary}
            sx={{
              fontSize: "1.1rem",
              fontWeight: "500"
            }}
          >
            {`${getCommaFormattedNumber(vehicleData?.Mileage)} ${vehicleData?.Mileage_Unit} |${vehicleData?.auction_type === localAuction ? ` ${t(`Local market`)} |` : vehicleData?.auction_type === exportAuction ? ` ${t(`Export market`)} |` : ""}${vehicleData?.Live_Auction_DateTime ? ` ${t(`Live Auction`)} |` : vehicleData?.Buy_now_DateTime ? ` ${t(`Buy Now`)} |` : ""} ${vehicleData?.VIN}`}
            {/* 81,225 km | AWD | LE | 7MUCAABGXPV075585 */}
          </Typography>
        </Box> : null}

        {/* OUTSIDE CAROUSEL (NO CATEGORY BUTTONS) */}
        <CardContent sx={{ p: 2 }}>
          <Box display="flex" flexDirection="column" alignItems="center" gap="0.75rem" sx={{ width: '100%' }}>
            {/* Outer viewport */}
            <Box sx={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
              <Box
                sx={{
                  display: 'flex',
                  gap: "0.5rem",
                  // width: `${(mediaItems.length / 4) * 100}%`,
                  width: "100%",
                  transform: `translateX(-${index * (200 / mediaItems.length)}%)`,
                  transition: 'transform 0.5s ease-in-out',
                }}
              >
                {mediaItems.map((item, i) => (
                  <Box
                    key={i}
                    sx={{
                      flex: '0 0 33%',
                      height: 300,
                      position: 'relative',
                      borderRadius: '1rem',
                      overflow: 'hidden',
                      border: '1px solid #f0f0f0',
                      bgcolor: 'white',
                      cursor: 'pointer',
                    }}
                    onClick={() => openModalAt(i)}
                  >
                    {item.type === 'video' ? (
                      <>
                        <Box component="video" src={item.src} muted sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            bgcolor: 'rgba(0,0,0,0.7)',
                            borderRadius: '50%',
                            width: 48,
                            height: 48,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                          }}
                        >
                          <PlayArrow sx={{ fontSize: 28 }} />
                        </Box>
                      </>
                    ) : (
                      <React.Fragment key={i}>
                        <Box component="img" src={item.src} alt={item.alt} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </React.Fragment>
                    )}
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Controls */}
            <Box display="flex" justifyContent="center" alignItems="center" gap="0.3rem" width="50%">
              <IconButton onClick={handlePrev} sx={{ p: 0, mr: '8px', color: '#1976d2' }} disabled={index === 0}>
                <ArrowCircleLeftOutlined />
              </IconButton>

              <IconButton
                onClick={handleNext}
                sx={{ p: 0, ml: '8px', color: '#1976d2' }}
                disabled={index >= mediaItems.length - 4}
              >
                <ArrowCircleRightOutlined />
              </IconButton>
            </Box>
          </Box>
        </CardContent>

        {/* MODAL WITH CATEGORY BUTTONS */}
        <Modal open={showCarousel} onClose={() => setShowCarousel(false)} keepMounted sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Box
            sx={{
              position: 'relative',
              width: { xs: '90%', sm: '80%', md: '70%', lg: '60%' },
              maxWidth: '900px',
              maxHeight: '90vh',
              bgcolor: 'white',
              borderRadius: '8px',
              boxShadow: 24,
              outline: 'none',
              overflow: 'hidden',
              border: '1px solid #f0f0f0',
            }}
          >
            {/* Category Buttons (INSIDE MODAL ONLY) */}
            <Box display="flex" gap={1} p={2}>
              {Object.keys(categorizedMedia).map((cat) => (
                <Box
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  sx={{
                    cursor: 'pointer',
                    px: 2,
                    py: '6px',
                    borderRadius: '8px',
                    bgcolor: selectedCategory === cat ? '#1976d2' : '#e0e0e0',
                    color: selectedCategory === cat ? 'white' : 'black',
                    fontWeight: 600,
                    fontSize: '0.9rem',
                    textTransform: 'capitalize',
                  }}
                >
                  {cat}
                </Box>
              ))}
            </Box>

            {/* Close Btn */}
            <IconButton
              onClick={() => setShowCarousel(false)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                zIndex: 2,
                bgcolor: 'rgba(0,0,0,0.5)',
                color: 'white',
                width: 36,
                height: 36,
              }}
            >
              <Close sx={{ fontSize: 18 }} />
            </IconButton>

            {/* Prev */}
            <IconButton
              onClick={handlePopupPrev}
              disabled={filteredItems.length <= 1}
              sx={{
                position: 'absolute',
                left: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 2,
                bgcolor: 'rgba(0,0,0,0.5)',
                color: 'white',
                width: 36,
                height: 36,
              }}
            >
              <ChevronLeft sx={{ fontSize: 18 }} />
            </IconButton>

            {/* Next */}
            <IconButton
              onClick={handlePopupNext}
              disabled={filteredItems.length <= 1}
              sx={{
                position: 'absolute',
                right: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 2,
                bgcolor: 'rgba(0,0,0,0.5)',
                color: 'white',
                width: 36,
                height: 36,
              }}
            >
              <ChevronRight sx={{ fontSize: 18 }} />
            </IconButton>

            {/* Modal Image */}
            <Box sx={{ width: '100%', minHeight: '300px', display: 'flex', flexDirection: "column", alignItems: 'center', justifyContent: 'center', pb: 5 }}>
              {filteredItems[popUpImageIndex]?.type === 'video' ? (
                <Box component="video" controls autoPlay src={filteredItems[popUpImageIndex]?.src} sx={{ maxWidth: '100%', maxHeight: '100%' }} />
              ) : (
                <>
                <img
                  src={filteredItems[popUpImageIndex]?.src}
                  alt={filteredItems[popUpImageIndex]?.alt}
                  style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: 4 }}
                />
                {/* {filteredItems[popUpImageIndex]?.label ? <Typography>
                  Note: {filteredItems[popUpImageIndex]?.label}
                </Typography> : null} */}
                </>
              )}
            </Box>

            {/* Counter */}
            <Box
              sx={{
                position: 'absolute',
                bottom: 12,
                left: '50%',
                transform: 'translateX(-50%)',
                bgcolor: 'rgba(0,0,0,0.7)',
                color: 'white',
                px: 1.5,
                py: 0.5,
                borderRadius: '12px',
                fontSize: '0.75rem',
                fontWeight: 500,
              }}
            >
              {popUpImageIndex + 1} / {filteredItems.length}
            </Box>
          </Box>
        </Modal>
      </Card>
    </>
  );
};
